import { cn } from "@ui/lib";

export interface ExampleRequest {
	/** What the shopper writes, in their own script and dialect. */
	text: string;
	/** What it means, in English. */
	en: string;
	/** What a good assistant does with it (the test pages show this). */
	expect?: string;
}

/** Shopper requests as people really write them, each with its meaning, as chat bubbles. */
export function ExampleRequests({
	items,
	className,
}: {
	items: ExampleRequest[];
	className?: string;
}) {
	return (
		<ul className={cn("grid gap-3 sm:grid-cols-2", className)}>
			{items.map((item) => (
				<li
					key={item.text}
					className="mk-reveal rounded-[22px] bg-(--mk-white) p-4"
				>
					<p
						dir="auto"
						className="w-fit max-w-full rounded-[18px] rounded-br-md bg-(--mk-ink) px-3.5 py-2 text-(--mk-white) text-[16px] leading-snug"
					>
						{item.text}
					</p>
					<p className="mt-2 text-(--mk-muted) text-[14px]">
						{item.en}
					</p>
					{item.expect ? (
						<p className="mt-2 border-(--mk-line) border-t pt-2 text-(--mk-ink-2) text-[14px] leading-snug">
							{item.expect}
						</p>
					) : null}
				</li>
			))}
		</ul>
	);
}
